export function pageGreeting(user) {
  const candidates = [user?.displayName, user?.firstName, user?.name];
  for (const value of candidates) {
    const text = String(value || "").trim();
    if (!text || text.includes("@") || text.length > 22 || /\d{3,}/.test(text)) continue;
    return text.split(/\s+/)[0];
  }
  const local = String(user?.email || "").split("@")[0] || "";
  if (/^[A-Za-z][A-Za-z]{1,14}$/.test(local)) {
    return local.charAt(0).toUpperCase() + local.slice(1).toLowerCase();
  }
  return "";
}

export function taskStage(plan) {
  if (plan?.archivedAt) return "Archived";
  if (plan?.status === "generating") return "Planning";
  if (plan?.deliveredWork?.headSha) return "Delivered";
  if (plan?.status === "completed") return "Plan";
  if (plan?.status === "failed" || plan?.status === "insufficient_evidence") return "Needs attention";
  if (plan?.status === "rejected") return "Changes requested";
  if (plan?.acceptance?.status === "accepted" || plan?.customerOrigin?.acceptedAt) return "Accepted";
  return "Draft";
}

export function taskOriginLabel(plan) {
  const type = plan?.customerOrigin?.type || plan?.origin?.type;
  if (type === "decision_review") return "From Decision Review";
  if (type === "guide") return "From Guide";
  if (type === "roadmap") return "From roadmap";
  if (type === "acceptance_correction") return "From Acceptance correction";
  return "Created manually";
}

export function taskMatchesFilter(plan, filter = "needs-me") {
  const stage = taskStage(plan);
  if (!filter || filter === "needs-me") return stage === "Draft" || stage === "Needs attention" || stage === "Delivered";
  if (filter === "draft") return stage === "Draft";
  if (filter === "planning") return stage === "Planning";
  if (filter === "ready" || filter === "plan") return stage === "Plan";
  if (filter === "delivered" || filter === "verifying") return stage === "Delivered";
  if (filter === "building") return stage === "Building";
  if (filter === "changes-requested" || filter === "changes") return stage === "Changes requested";
  if (filter === "accepted") return stage === "Accepted";
  if (filter === "archived") return stage === "Archived";
  return true;
}

export function buildDashboardModel({ setup, reviews = [], plans = [], guides = [] }) {
  const attention = [];
  for (const review of reviews) {
    if (review.currentState === "current" && review.status === "completed" && review.verdict && review.verdict !== "aligned") {
      attention.push({
        id: `review-${review.id}`,
        title: review.title || `${review.owner}/${review.name} #${review.pullNumber}`,
        detail: "Review finding ready to become a Task",
        action: "Open review",
        href: `/reviews/${review.id}`,
      });
    }
  }
  for (const plan of plans) {
    const stage = taskStage(plan);
    if (stage === "Draft" || stage === "Needs attention" || stage === "Delivered") {
      attention.push({
        id: `task-${plan._id || plan.id}`,
        title: plan.title || plan.featureRequestText || "Task",
        detail: stage === "Delivered" ? "Delivery ready for verification" : "Task needs a decision",
        action: "Open task",
        href: `/tasks/${plan._id || plan.id}`,
      });
    }
  }
  if (setup?.reviewReady === false && Number(setup?.privateRepositoryCount) > 0) {
    attention.push({
      id: "private-access",
      title: "Private repository access is disconnected",
      detail: "Reconnect GitHub before reviewing a private repository.",
      action: "Open settings",
      href: "/settings",
    });
  }
  const activeGuides = guides.filter((guide) => guide.isActive !== false);
  return {
    attention: attention.slice(0, 8),
    activeTasks: plans.filter((plan) => taskStage(plan) !== "Archived").slice(0, 6),
    recentReviews: reviews.slice(0, 6),
    guideCount: activeGuides.length,
    guidesNeedingReview: guides.filter((guide) => guide.isActive === false).length,
    recentGuide: activeGuides[0] || null,
    showSetup: setup?.reviewReady === false,
    publicationOptional: setup?.publicationPossible !== true,
  };
}
